import { ClockCircleOutlined } from "@ant-design/icons";
import { Result, Typography } from "antd";

interface ComingSoonPageProps {
	title: string;
	description?: string;
}

export function ComingSoonPage({
	title,
	description = "Bu sahifa tez orada ishga tushiriladi",
}: ComingSoonPageProps) {
	return (
		<div>
			<Typography.Title level={4} className="mb-4!">
				{title}
			</Typography.Title>
			<Result
				icon={<ClockCircleOutlined style={{ color: "#8c8c8c" }} />}
				title="Tez kunda"
				subTitle={description}
			/>
		</div>
	);
}
